module.exports = __webpack_public_path__ + "static/img/rotate04.033d886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate04.png
// module id = u64p
// module chunks = 1